import React from 'react';
import { Component } from '@/types/interfaces';

export interface GridProps extends Component {
  children: React.ReactNode;
}

const GridContainer: React.FC<GridProps> = ({ className, children }) => {
  const classString = ['grid', 'grid-cols-12', 'gap-l', className]
    .filter((c) => c !== '')
    .join(' ');
  return <div className={classString}>{children}</div>;
};

export default GridContainer;
